export const clientsBulkConfig = {
  tableName: 'clients',
  requiredFields: ['name'],
  fieldMappings: {
    name: {
      type: 'string',
      required: true,
      maxLength: 100,
      label: 'Client Name'
    },
    email: {
      type: 'string',
      required: true,
      pattern: /^.+@.+\..+$/,
      label: 'Email'
    },
    phone: {
      type: 'string',
      required: false,
      maxLength: 20,
      label: 'Phone Number'
    },
    company: {
      type: 'string',
      required: false,
      maxLength: 100,
      label: 'Company'
    },
    country: {
      type: 'string',
      required: false,
      maxLength: 50,
      label: 'Country'
    },
    city: {
      type: 'string',
      required: false,
      maxLength: 50,
      label: 'City'
    },
    address: {
      type: 'string',
      required: false,
      maxLength: 255,
      label: 'Address'
    },
    postal_code: {
      type: 'string',
      required: false,
      maxLength: 20,
      label: 'Postal Code'
    },
    contact_person: {
      type: 'string',
      required: false,
      maxLength: 100,
      label: 'Contact Person'
    },
    notes: {
      type: 'string',
      required: false,
      maxLength: 500,
      label: 'Notes'
    },
    is_active: {
      type: 'boolean',
      required: false,
      default: true,
      label: 'Is Active'
    }
  },
  validateItem: (item) => {
    const errors = [];
    
    // Check required fields
    clientsBulkConfig.requiredFields.forEach(field => {
      if (!item[field]) {
        errors.push(`${field} is required`);
      }
    });

    // Validate email format
    if (item.email && !clientsBulkConfig.fieldMappings.email.pattern.test(item.email)) {
      errors.push('Invalid email format');
    }

    // Validate boolean fields
    if (item.is_active !== undefined && item.is_active !== null) {
      const value = item.is_active;
      if (typeof value === 'string') {
        const lowerValue = value.toLowerCase();
        if (!['true', 'false', '1', '0', 'yes', 'no', 'si', 'sí'].includes(lowerValue)) {
          errors.push('is_active must be true/false, yes/no, or 1/0');
        }
      } else if (typeof value !== 'boolean' && value !== 1 && value !== 0) {
        errors.push('is_active must be a boolean value');
      }
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  }
}; 